module.exports = __webpack_public_path__ + "img/ranking_icon.5c4398a5.svg";